import type { WorldCupTab } from '../types/worldcup.types';
import { WORLD_CUP_BASE_PATH } from '../../competitions/contexts/competitionContext.constants';
import {
  getActiveCompetitionTab,
  resolveCompetitionBackRoute,
} from '../../competitions/helpers/competitionRoutes.helper';

/**
 * World Cup surface bindings of the shared competition route helpers
 * (specs/competitions-hub-client Slice 3). Signatures and behavior are unchanged —
 * these delegate with `surface: 'worldcup'` so the WC tree keeps its own semantics.
 */

/**
 * Where the member-profile back button lands when there's no history to pop
 * (e.g. after a refresh or a deep link). Prefers the originating squad, then the
 * originating WC tab (`wcTab`), and finally the WC home — never the arena.
 */
export function resolveWorldCupBackRoute(groupId?: string | null, wcTab?: string | null): string {
  return resolveCompetitionBackRoute(WORLD_CUP_BASE_PATH, groupId, wcTab);
}

/**
 * Resolves which World Cup sub-tab (Picks / Leaderboard / Squads) should be highlighted.
 * `member-profile` is not under `groups/`, so we use optional `wcTab` from navigation params.
 */
export function getActiveTabFromPath(
  pathname: string,
  searchParams?: Record<string, string | string[] | undefined>
): WorldCupTab {
  return getActiveCompetitionTab(pathname, 'worldcup', searchParams);
}
